// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__25miP","title":"Images45_title__1wKSJ","images":"Images45_images__3CWAA"};